import styled from 'styled-components';
import { NavLink as Link } from 'react-router-dom';

const NavLink = styled(Link)`
  display: flex;
  align-items: center;

  color: #c5cede;
  padding: 0 0.5rem;
  margin: 0 1rem;

  font-weight: bold;
  text-decoration: none;
  border-bottom: solid transparent 0.2rem;
  border-top: solid transparent 0.2rem;
  transition: color 0.3s;

  &.active {
    color: #edece8;
    border-top: solid #f56249 0.2rem;
  }

  &:hover {
    color: #edece8;
  }
`;

export default NavLink;
